<template>
<div>
    <div class="flex flex-wrap border-b-2">
        <div
            v-for="(item, key) in tabs" :key="'tab_' + key"
        >
            <button
                v-if="!link"
                class="h-full  rounded-t-md p-2 mr-1 -mb-0.5 flex justify-center font-semibold transition duration-300"
                :class="{
                    ['bg-gray-900 text-gray-200'] : checked == item.slug,
                    ['hover:bg-gray-100 text-gray-900'] : checked != item.slug,
                }"
                @click="checked = item.slug; loading = true;"
            >
                {{ __(item.title, null, lang ? lang : $page.props.locale) }}
            </button>
            <InertiaLink
                v-else
                :href="route(item.route)"
                @click="loading = true"
                class="h-full  rounded-t-md p-2 mr-1 -mb-0.5 flex justify-center font-semibold transition duration-300"
                :class="{
                    ['bg-gray-900 text-gray-200'] : route().current(item.route) || route().current(item.route + '.*'),
                    ['hover:bg-gray-100 text-gray-900'] : !route().current(item.route) && !route().current(item.route + '.*'),
                }"
            >
                {{ __(item.title, null, lang ? lang : $page.props.locale) }}
            </InertiaLink>
        </div>
    </div>

    <slot />
</div>
</template>

<script>
import { ref } from '@vue/reactivity';
import { inject, provide } from '@vue/runtime-core';

export default {
    props: ['tabs', 'link', 'lang'],
    name: 'Tabs',
    setup(props, { slots }){

        const checked = ref(!props.link ? props.tabs[0].slug : '');

        props.tabs.forEach(el => {
            if(el.route && route().current(el.route)) {
                checked.value = el.slug;
            }
        });

        provide('active', checked);
        const loading = props.link ? inject('loading') : null;

        return {
            checked,
            loading
        }
    }
}
</script>

<style>

</style>
